<div class="flex flex-col gap-1">
  <div class="typo-h4-semibold text-text-primary">
    {{ treatment.treatmentName }}
  </div>
  <button class="inline-flex items-center gap-1" (click)="onToggleClick()">
    <span class="typo-h5-light text-text-primary">{{
      (opened ? 'charting_treatment_plan_table_less_details' : 'charting_treatment_plan_table_more_details') | translate
    }}</span>
    <svg-icon class="text-primary-blue transition-transform" [class.rotate-180]="opened" key="px-16-arrow-down" size="sm"></svg-icon>
  </button>
</div>
<div>
  @if (treatment.provisionalStatus) {
    <svg-icon
      class="mr-1 shrink-0 rounded-full text-text-light"
      key="px-12-hourglass"
      size="sm"
      [libUiTooltip]="provisionalTooltip"
      tooltipPosition="bottom"
    />
    <ng-template #provisionalTooltip>
      <div class="typo-h7-light p-2">
        {{ 'schedule_provisional_appointment_tooltip' | translate }}
      </div>
    </ng-template>
  }
</div>
<div class="typo-h3-semibold text-right text-text-primary">{{ treatment.cost | currency: 'USD' : 'symbol' : '1.0-0' }}</div>
<lib-checkbox [formControl]="isSelectedControl" />
<div
  class="col-start-1 col-end-[-1] flex flex-col border-background-white transition-all"
  [ngClass]="{
    'mt-3 border-t pt-3': opened || treatment.treatmentDescription
  }"
>
  <div class="typo-h4-light-line-height-20 transition-all" [ngClass]="opened ? 'line-clamp-6 max-h-[120px]' : 'line-clamp-2 max-h-[40px]'">
    {{ treatment.treatmentDescription }}
  </div>
  <div class="grid transition-all" [style.gridTemplateRows]="opened ? '1fr' : '0fr'">
    <div class="mt-2 flex flex-col gap-4 overflow-hidden">
      <div class="flex items-center gap-1">
        <div class="typo-h5-semibold rounded-lg bg-primary-blue/[0.12] px-2 pb-0.5 pt-[3px] text-primary-blue">
          {{ treatment.dentalCode }}
        </div>
        @if (treatment.toothPosition) {
          <div class="typo-h5-semibold rounded-lg bg-primary-blue/[0.12] px-2 pb-0.5 pt-[3px] text-primary-blue">
            {{ treatment.toothPosition }}
          </div>
        }
        @if (treatment.surfaces) {
          <div class="typo-h5-semibold rounded-lg bg-primary-blue/[0.12] px-2 pb-0.5 pt-[3px] text-primary-blue">
            {{ treatment.surfaces }}
          </div>
        }
      </div>
      <lib-dropdown
        class="w-min"
        [overlayPositionStrategy]="overlayPositionStrategy"
        [options]="providers"
        [value]="treatment.selectedProviderId || ''"
        [label]="'Provider'"
        background="white"
        (valueChange)="onProviderChange($event)"
      >
      </lib-dropdown>
    </div>
  </div>
</div>
